import { createSagaAction } from '../../shared/sagas'
import { createReducer } from '../../shared/reducers'

// Constants
export const constants = {
  GET_ALL_TASKS: createSagaAction('GET_ALL_TASKS'),
  TASKS_REFRESH: createSagaAction('TASKS_REFRESH'),
  CREATE_TASK: createSagaAction('CREATE_TASK'),
  EDIT_TASK: createSagaAction('EDIT_TASK'),
  DELETE_TASK: createSagaAction('DELETE_TASK'),
  // ADDED THE 'MAIN' ON PREFIX TO PREVENT COMFLICT WITH OTHER ACTIONS WITH THE SAME NAME
  // ON A FUTURE REFACTORY WE NEED TO CHANGE ALL OTHER TASK QUICK ADDS ACTIONS FOR THIS ONE
  MAIN_QUICK_ADD_TASK: createSagaAction('MAIN_QUICK_ADD_TASK')
}

// Action Creators
export const actions = {
  tasksRefresh: () => ({ type: constants.TASKS_REFRESH.ACTION }),

  getAllTasks: () => ({
    type: constants.GET_ALL_TASKS.ACTION
  }),
  createTask: ({ content, userId }) => ({
    type: constants.CREATE_TASK.ACTION,
    content,
    userId
  }),
  editTask: ({ content, taskId }) => ({
    type: constants.EDIT_TASK.ACTION,
    content,
    taskId
  }),
  deleteTask: ({ taskId }) => ({
    type: constants.DELETE_TASK.ACTION,
    taskId
  }),
  mainQuickAddTask: ({ task, userId }) => ({
    type: constants.MAIN_QUICK_ADD_TASK.ACTION,
    task,
    userId
  })
}

// Reducer
const initialState = [
  {
    name: ''
  }
]

export default createReducer(initialState, (state, { type, payload }) => {
  switch (type) {
    default:
      return state
    case constants.TASKS_REFRESH.SUCCESS:
      return { ...state, payload }
    case constants.GET_ALL_TASKS.ACTION:
      return { ...state, error: null, loading: true }
    case constants.GET_ALL_TASKS.SUCCESS:
      return {
        ...state,
        allTasks: payload
      }
    case constants.CREATE_TASK.ACTION:
      return { ...state, loading: true }
    case constants.CREATE_TASK.SUCCESS:
      return {
        ...state,
        loading: false,
        msg: 'Task created!'
      }
    case constants.CREATE_TASK.FAILED:
      return {
        ...state,
        loading: false,
        msg: 'Problems creating task, please try again.'
      }
    case constants.EDIT_TASK.SUCCESS:
      return {
        ...state,
        loading: false,
        msg: 'Task edited!'
      }
    case constants.EDIT_TASK.FAILED:
      return {
        ...state,
        loading: false,
        msg: 'Problems editing task, please try again.'
      }
    case constants.DELETE_TASK.SUCCESS:
      return {
        ...state,
        loading: false,
        msg: 'Task deleted!'
      }
    case constants.DELETE_TASK.FAILED:
      return {
        ...state,
        loading: false,
        msg: 'Problems deleting task, please try again.'
      }
    case constants.MAIN_QUICK_ADD_TASK.SUCCESS:
      return {
        ...state
      }
  }
})



// WEBPACK FOOTER //
// ./src/redux/modules/tasksActions.js